module.exports = __webpack_public_path__ + "img/varified-icon.97eba7a7.svg";